type Props = {
  value: string
  label: string
}

export default function Stat({ value, label }: Props) {
  return (
    <div className='m-[-0.5px] border p-3'>
      <div className='inline-block bg-gray-900 px-sm font-bold text-gray-50 dark:bg-gray-50 dark:text-gray-900'>
        {value}
      </div>
      <div className='mt-1 text-secondary'>{label}</div>
    </div>
  )
}

Stat.scheme = {
  render: 'Stat',
  selfClosing: true,
  attributes: {
    value: { type: String, required: true },
    label: { type: String, required: true }
  }
}
